// extracted by mini-css-extract-plugin
module.exports = {"Loader":"scheme_Loader__ZAej7"};